import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    oldKnowledgeAssociations: [],
  },
  mutations: {
    SET_OLD_KNOWLEDGE_ASSOCIATIONS(state: any, oldKnowledges: Array<any>) {
      state.oldKnowledgeAssociations = oldKnowledges;
    },
  },
  actions: {
    async PULL_OLD_KNOWLEDGE_ASSOCIATIONS({ commit }: any) {
      const response = await query(
        `query getDistinctKnowledgeAssociationsDexAdmin{
          getDistinctKnowledgeAssociations{
            nodes{
              knowledge{
                id
                name
              }
              associationsCount
            }
          }
        }`,
      );
      commit(
        'SET_OLD_KNOWLEDGE_ASSOCIATIONS',
        response.data.getDistinctKnowledgeAssociations.nodes,
      );
    },
    async REDEFINE_OLD_KNOWLEDGE_ASSOCIATIONS(
      { commit }: any,
      { oldKnowledgeId, newLtreeKnowledgesId, skipInsertion },
    ) {
      await mutation(
        `mutation RedefineOldKnowledge(
          $oldKnowledgeId: Int!,
          $newLtreeKnowledgesId: Int,
          $skipInsertion: Boolean
        ) {
          redefineAssociations(input:{
            oldKnowledgeId: $oldKnowledgeId,
            newLtreeKnowledgesId: $newLtreeKnowledgesId,
            skipInsertion: $skipInsertion
          }){
            clientMutationId
          }
        }`,
        {
          oldKnowledgeId,
          newLtreeKnowledgesId: newLtreeKnowledgesId
            ? newLtreeKnowledgesId
            : null,
          skipInsertion: skipInsertion ? skipInsertion : null,
        },
      );
    },
  },
};
